<template>
  <div>
    <div
      class="has-margin-bottom-40 has-margin-top-50 has-border-bottom"
      v-if="data.additional_handling_information || data.certificate_documents || data.uploaded_documents"
    >
      <h2
        class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
      >additional information</h2>
    </div>

    <div class="columns is-multiline">
      <!-- Additional Shipping Information -->
      <div class="column is-12" v-if="data.additional_handling_information">
        <b-field label="Additional Shipping Information ">
          <b-input :type="'textarea'" v-model="data.additional_handling_information" readonly></b-input>
        </b-field>
      </div>
      <div class="column is-12 has-text-grey has-text-centered has-padding-30 has-margin-0 is-size-4 has-background-white" v-else>
       <div>No Additional Handling Information</div>
      </div>

      <div class="column is-12">
        <div
        class="has-margin-bottom-40 has-margin-top-50 has-border-bottom"
        v-if="data.additional_handling_information || data.certificate_documents || data.uploaded_documents"
      >
        <h2
          class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
        >additional Documentation</h2>
      </div>
        <UploadedDocuments
          v-if="data.uploaded_documents || data.certificate_documents"
          :documents="data.uploaded_documents || data.certificate_documents"
          :ref_no="data.reference_number"
        ></UploadedDocuments>
      </div>
    </div>
  </div>
</template>

<script>
import UploadedDocuments from "../viewShippingRequestDetails/UploadedDocuments";
export default {
  name: "ShipperDetail",
  components: { UploadedDocuments },
  props: {
    data: Object
  },
  data() {
    return {};
  }
};
</script>
